//const API_BASE_URL="http://localhost:3000"; // Localhost
//const API_BASE_URL="https://api-be-archivos-dot-poc-banco-estado.appspot.com"; // Produccion 
// exports.get = () => API_BASE_URL;

export const SIZE_FILE =  30000000;
export const API_BASE_URL  = process.env.NODE_ENV === 'production'
    ? 'https://backend-web-mutual-cadem-dev-rr2353muea-ue.a.run.app' // Produccion Cloud Run                               
    : 'http://localhost:4040'; // Desarrollo